/** User roles matching backend UserRole enum */
export type UserRole =
  | 'intake_coordinator'
  | 'document_specialist'
  | 'qc_operator'
  | 'proofreader'
  | 'manager'
  | 'admin';

/** Authenticated user payload from JWT */
export interface AuthUser {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  department_id?: string;
  client_context?: string[];
  is_active: boolean;
}

/** Login request payload */
export interface LoginRequest {
  tenant_code: string;
  username: string;
  password: string;
}

/** Login response from POST /auth/login */
export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

/** Role display config — maps backend roles to frontend labels */
export const ROLE_CONFIG: Record<UserRole, { label: string; shortLabel: string }> = {
  intake_coordinator: { label: 'Intake Coordinator', shortLabel: 'Coordinator' },
  document_specialist: { label: 'Document Specialist', shortLabel: 'Specialist' },
  qc_operator: { label: 'QC Operator', shortLabel: 'QC' },
  proofreader: { label: 'Proofreader', shortLabel: 'Proofreader' },
  manager: { label: 'Manager', shortLabel: 'Manager' },
  admin: { label: 'Administrator', shortLabel: 'Admin' },
};

/** Maps backend roles to the compact navigation role keys. */
export const ROLE_TO_NAV_KEY: Record<UserRole, string> = {
  intake_coordinator: 'coord',
  document_specialist: 'spec',
  qc_operator: 'qc',
  proofreader: 'proof',
  manager: 'coord',
  admin: 'coord',
};
